import FieldPhoneFax from './FieldPhoneFax';
export default FieldPhoneFax;
